<!-- Builder Start -->
<div id="{{position}}" class="position-relative">
  <div>
    <header class="app-header-background cta-app-header-background"
      [ngStyle]="{'background-image': style, 'min-height':minHeight+'px'}"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div *ngIf="imageBackground && !isString(imageBackground) && imageBackground &&  imageBackground.length>0"
        class="center pb-20 pt-20 slider-tms-bullet-nav ">
        <ng-container *ngFor="let item of imageBackground; let i = index">
          <span class="tms-bullet-nav" (click)="nextSliderClick(i)"
            [ngClass]="sliderIndex === i ? 'tms-bullet-nav active' : 'tms-bullet-nav'"></span>
        </ng-container>
      </div>
    </header>
  </div>
</div>
<!-- Builder End -->

<img *ngIf="sliderIndex>-1 && !isString(imageBackground) && imageBackground[sliderIndex]" style="display: none;"
  [src]="imageBackground[sliderIndex]" class="hero-image" [alt]="title" (error)="updateUrl($event)">